module.exports = __webpack_public_path__ + "img/img-tabs-1-4.c200e2f6.svg";